(function () {
  function fixIframeTitles() {
    // Cookie Policy Banner iframe
    document
      .querySelectorAll('.pieeye-consent-container iframe#myFrame')
      .forEach(function (frame) {
        if (!frame.getAttribute('title')?.trim()) {
          frame.setAttribute('title', 'Cookie Policy Banner');
        }
      });

    // Shopify Web Pixel sandbox iframe
    document
      .querySelectorAll('iframe[name^="web-pixel-sandbox-"]')
      .forEach(function (frame) {
        if (!frame.getAttribute('title')?.trim()) {
          frame.setAttribute('title', 'Shopify analytics pixel');
        }
      });
  }

  //Fix Klaviyo Reviews missing tabindex
  function fixKlaviyoReviewsFocus() {
    document
      .querySelectorAll(
        '.kl_reviews__histogram__clickable_row[role="button"]'
      )
      .forEach(function (element) {
        if (!element.hasAttribute('tabindex')) {
          element.setAttribute('tabindex', '0');
        }
      });
  }

    // Back in Stock floating button accessibility
    function fixBackInStockFocus() {
    document
        .querySelectorAll('#product-restore-email-float[role="button"]')
        .forEach(function (element) {
        if (!element.hasAttribute('tabindex')) {
            element.setAttribute('tabindex', '0');
        }
        });
    }

  function applyAccessibilityFixes() {
    fixIframeTitles();
    fixKlaviyoReviewsFocus();
    fixBackInStockFocus();
  }

  function init() {
    applyAccessibilityFixes();

    var observer = new MutationObserver(applyAccessibilityFixes);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();